import { api } from "./api";

const CUSTOMER_INFO_KEY = "authoros_customer_info";

// Persist last-known customer contact so events + checkout can prefill.
export function saveCustomerInfo(info) {
  try {
    const prev = readCustomerInfo() || {};
    const next = { ...prev, ...info };
    localStorage.setItem(CUSTOMER_INFO_KEY, JSON.stringify(next));
    return next;
  } catch (_e) {
    return info;
  }
}

export function readCustomerInfo() {
  try {
    const raw = localStorage.getItem(CUSTOMER_INFO_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_e) {
    return null;
  }
}

// Fire an activity event. Silently swallows errors.
export async function trackEvent({
  eventType = "page_view",
  url,
  path,
  pageTitle,
  serviceCode,
  subCode,
  meta,
} = {}) {
  try {
    const info = readCustomerInfo() || {};
    const email = (info.email || localStorage.getItem("authoros_email") || "").trim();
    const phone = (info.phone || "").trim();
    await api.post("/events", {
      email,
      phone,
      url: url || window.location.href,
      path: path || window.location.pathname,
      page_title: pageTitle || document.title || "",
      service_code: serviceCode || "",
      sub_code: subCode || "",
      event_type: eventType,
      referrer: document.referrer || "",
      user_agent: navigator.userAgent || "",
      meta: meta || null,
    });
  } catch (_e) {
    /* swallow */
  }
}
